import { GiSleevelessJacket } from "react-icons/gi";
import { IoShirtOutline } from "react-icons/io5";
import {
  PiBaseballCap,
  PiHandbag,
  PiHandbagSimple,
  PiPantsLight,
  PiShirtFolded,
  PiSneaker,
  PiWatchLight,
} from "react-icons/pi";

import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as CoatIcon } from "../../assets/images/icons/coat.svg";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
const Wrapper = styled.div`
  background-color: ${colors.backgroundSurfacePrimary};
  padding: 40px 0;
  color: ${colors.black};
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  justify-items: center;
`;

const CategoryCard = styled.div`
  width: 80px;
  height: 80px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: transform 0.2s ease;
  cursor: pointer;
  &:hover {
    background-color: #a7a7a749;
  }
`;

const IconWrapper = styled.div`
  margin-bottom: 12px;

  svg {
    width: 32px;
    height: 32px;
    stroke: ${colors.black};
    /* fill: black; */
    /* stroke-width: 1.5; */
  }
`;

const CategoryName = styled.span`
  font-size: ${fontSize.s};
  font-weight: 300;
  color: ${colors.black};
`;

function AllCategoriesBanner() {
  const navigate = useNavigate();
  const categories = [
    {
      name: "Topwear",
      icon: <IoShirtOutline />,
    },
    {
      name: "Bottomwear",
      icon: <PiPantsLight />,
    },
    {
      name: "Outerwear",
      icon: <GiSleevelessJacket />,
    },
    // {
    //   name: "Sets",
    //   icon: <CoatIcon />,
    // },
    // {
    //   name: "Sweater & Inners",
    //   icon: <PiShirtFolded />,
    // },
    {
      name: "Accessories",
      icon: <PiBaseballCap />,
    },
    {
      name: "Footwear",
      icon: <PiSneaker />,
    },
    {
      name: "Bags",
      icon: <PiHandbagSimple />,
    },
  ];

  return (
    <Wrapper>
      <Container>
        <Grid>
          {categories.map((cat, index) => (
            <CategoryCard
              key={index}
              onClick={() => {
                navigate(`/products/${cat.name}`);
              }}
            >
              <IconWrapper>{cat.icon}</IconWrapper>
              <CategoryName>{cat.name}</CategoryName>
            </CategoryCard>
          ))}
        </Grid>
      </Container>
    </Wrapper>
  );
}

export default AllCategoriesBanner;
